<template>
  <div class="for-job-seekers" id="view">
    <hero-section
      :title="title"
      :subTitle="subTitle"
      :description="description"
      :imageName="imageName"
      :navIndicator="navIndicator"
    />
    <benefits-section />
    <developer-stories
      :hasPB="true"
      backgroundColor="#DEF3FF"
    ></developer-stories>
    <main-section />
    <global-contact-section
      :titleSans="'Become a'"
      :titleSerif="'DIGU Verified Professional'"
      :hasSolidButton="true"
      :solidButtonText="'Learn More'"
      :solidButtonUrl="'/verified-badges'"
    />
  </div>
</template>

<script>
import HeroSection from '@/components/partials/HeroSection.vue';
import BenefitsSection from './Sections/BenefitsSection.vue';
import GlobalContactSectionVue from '@/components/partials/GlobalContactSection.vue';
import DeveloperStories from './Sections/DeveloperStories.vue';
import MainSection from '@/views/career/Sections/MainSection.vue';

export default {
  name: 'ForDevelopers',
  components: {
    'hero-section': HeroSection,
    'benefits-section': BenefitsSection,
    'global-contact-section': GlobalContactSectionVue,
    'developer-stories': DeveloperStories,
    'main-section': MainSection,
  },
  data: () => ({
    description: `
      <span class="title--special" style="display: flex; align-items: center;  font-size: clamp(14px, 2vw, 20px);  color: #333; flex-wrap: wrap;">
        <span style="display: flex; align-items: center;  width: 200px">
          <img class="title__arrow" style="margin: 5px; margin-left:0; width: 20px;" src="${require('@/assets/img/right-arrow.svg')}" alt="right arrow" />
          <span class="title__text" style="margin: 5px; font-weight: 600; ">Career Growth</span> 
        </span>
        <span style="display: flex; align-items: center;  width: 180px">
          <img class="title__arrow" style="margin: 5px; margin-left:0; width: 20px;" src="${require('@/assets/img/right-arrow.svg')}" alt="right arrow" />
          <span class="title__text" style="margin: 5px; font-weight: 600; ">Higher Pay</span>
        </span>
        <span style="display: flex; align-items: center; flex-wrap: wrap; width: 220px">
          <img class="title__arrow" style="margin: 5px; margin-left:0; width: 20px;" src="${require('@/assets/img/right-arrow.svg')}" alt="right arrow" />
          <span class="title__text" style="margin: 5px; font-weight: 600;">Enhanced Living</span> 
        </span>
      </span>`,
    title: `
      <span style="font-size: clamp(26px, 5vw, 35px); margin-top: 0px; padding-top: 0px; font-weight: 700; color: #222;">
        WHY DIGU FOR 
        <span style="color: #FF6860;">CAREER OPPORTUNITIES</span>
      </span>`,
    imageName: 'carrier-opportunity.svg',
    navIndicator: [
      { text: 'Home', icon: 'fas fa-home', link: '/' },
      { text: 'For Job Seekers', link: '#' },
      { text: 'Why DIGU for Career Opportunities', link: '' },
    ],
  }),
  created() {
    document.getElementById('loaderSection').classList.add('d-none');
  },
};
</script>
